import './angular-css/style.css';
import './index.css';

require('./vendors');
require('./store');
require('./app');
require('./angular/app/documents');
require('./angular/app/workflow');
require('./angular/app/projects');
require('./angular/app/reports');
require('./angular/app/search');
require('./angular/app/saved-search');
require('./angular/common/grid');
require('./angular/common/columns');
require('./angular/common/auth');
require('./angular/common/alerts');
require('./angular/common/menu');
require('./angular/common/file');
require('./angular/common/util');
require('./angular/common/legacy');
require('./angular/common/dialog');
require('./angular/common/settings');
require('./angular/common/filters');
require('./angular/common/checkbox');
require('./angular/common/context-menu');
require('./angular/common/dragdrop');
require('./angular/common/profile');
require('./angular/common/properties');
require('./angular/common/section-panel');
require('./angular/common/preview');
require('./angular/common/multiselect');
require('./angular/common/path-select');
require('./angular/common/responsive');
require('./angular/common/tooltip');
require('./angular/common/upload');
require('./angular/common/header');
require('./angular/common/dropHandler');
require('./angular/common/project-editor');
require('./react-angular');

global.dlwebComponents = require('dlweb-components');

// suppress ResizeObserver errors in development
// https://stackoverflow.com/questions/49384120/resizeobserver-loop-limit-exceeded/50387233#50387233
if (process.env.NODE_ENV !== 'production') {
  window.addEventListener('error', e => {
      if (e.message.indexOf('ResizeObserver loop') > -1) {
          const resizeObserverErrDiv = document.getElementById(
              'webpack-dev-server-client-overlay-div'
          );
          const resizeObserverErr = document.getElementById(
              'webpack-dev-server-client-overlay'
          );
          if (resizeObserverErr) {
              resizeObserverErr.setAttribute('style', 'display: none');
          }
          if (resizeObserverErrDiv) {
              resizeObserverErrDiv.setAttribute('style', 'display: none');
          }
      }
  });
}